(function () {
  "use strict";

  var MOBILE_QUERY = "(max-width: 767.98px)";
  var SCAN_INTERVAL = 140;
  var CAMERA_IDEAL_WIDTH = 3840;
  var CAMERA_IDEAL_HEIGHT = 2160;
  var SCAN_MAX_WIDTH = 1920;
  var DISTANT_SCAN_CROP = 0.58;
  var EAN_L = [
    "0001101", "0011001", "0010011", "0111101", "0100011",
    "0110001", "0101111", "0111011", "0110111", "0001011"
  ];
  var EAN_G = [
    "0100111", "0110011", "0011011", "0100001", "0011101",
    "0111001", "0000101", "0010001", "0001001", "0010111"
  ];
  var EAN_R = [
    "1110010", "1100110", "1101100", "1000010", "1011100",
    "1001110", "1010000", "1000100", "1001000", "1110100"
  ];
  var EAN_PARITY = {
    LLLLLL: "0",
    LLGLGG: "1",
    LLGGLG: "2",
    LLGGGL: "3",
    LGLLGG: "4",
    LGGLLG: "5",
    LGGGLL: "6",
    LGLGLG: "7",
    LGLGGL: "8",
    LGGLGL: "9"
  };

  function hamming(a, b) {
    var distance = 0;
    for (var index = 0; index < a.length; index += 1) {
      if (a[index] !== b[index]) distance += 1;
    }
    return distance;
  }

  function closestDigit(bits, patterns) {
    var bestDigit = -1;
    var bestDistance = Infinity;

    patterns.forEach(function (pattern, digit) {
      var distance = hamming(bits, pattern);
      if (distance < bestDistance) {
        bestDistance = distance;
        bestDigit = digit;
      }
    });

    return bestDistance <= 1 ? String(bestDigit) : null;
  }

  function closestLeftDigit(bits) {
    var bestMatch = null;
    var bestDistance = Infinity;

    [
      { encoding: "L", patterns: EAN_L },
      { encoding: "G", patterns: EAN_G }
    ].forEach(function (group) {
      group.patterns.forEach(function (pattern, digit) {
        var distance = hamming(bits, pattern);
        if (distance < bestDistance) {
          bestDistance = distance;
          bestMatch = {
            digit: String(digit),
            encoding: group.encoding
          };
        }
      });
    });

    return bestDistance <= 1 ? bestMatch : null;
  }

  function isValidEan13(value) {
    if (!/^\d{13}$/.test(value)) return false;

    var sum = 0;
    for (var index = 0; index < 12; index += 1) {
      sum += Number(value[index]) * (index % 2 === 0 ? 1 : 3);
    }

    return (10 - (sum % 10)) % 10 === Number(value[12]);
  }

  function decodeEanBits(bits) {
    if (bits.length !== 95) return null;
    if (hamming(bits.slice(0, 3), "101") > 0) return null;
    if (hamming(bits.slice(45, 50), "01010") > 1) return null;
    if (hamming(bits.slice(92), "101") > 0) return null;

    var leftDigits = "";
    var parity = "";
    var rightDigits = "";

    for (var leftIndex = 0; leftIndex < 6; leftIndex += 1) {
      var leftBits = bits.slice(3 + leftIndex * 7, 10 + leftIndex * 7);
      var leftMatch = closestLeftDigit(leftBits);
      if (leftMatch === null) return null;

      leftDigits += leftMatch.digit;
      parity += leftMatch.encoding;
    }

    for (var rightIndex = 0; rightIndex < 6; rightIndex += 1) {
      var rightBits = bits.slice(50 + rightIndex * 7, 57 + rightIndex * 7);
      var rightDigit = closestDigit(rightBits, EAN_R);
      if (rightDigit === null) return null;
      rightDigits += rightDigit;
    }

    var firstDigit = EAN_PARITY[parity];
    if (firstDigit === undefined) return null;

    var barcode = firstDigit + leftDigits + rightDigits;
    return isValidEan13(barcode) ? barcode : null;
  }

  function buildRuns(binary) {
    var runs = [];
    var start = 0;

    for (var index = 1; index <= binary.length; index += 1) {
      if (index === binary.length || binary[index] !== binary[start]) {
        runs.push({
          color: binary[start],
          start: start,
          end: index,
          length: index - start
        });
        start = index;
      }
    }

    return runs;
  }

  function sampleCandidate(binary, start, end) {
    var width = end - start;
    var bits = "";

    for (var moduleIndex = 0; moduleIndex < 95; moduleIndex += 1) {
      var position = Math.min(
        binary.length - 1,
        Math.floor(start + ((moduleIndex + 0.5) * width) / 95)
      );
      bits += binary[position] ? "1" : "0";
    }

    return bits;
  }

  function decodeBinaryLine(binary) {
    var directions = [binary, binary.slice().reverse()];

    for (var directionIndex = 0; directionIndex < directions.length; directionIndex += 1) {
      var currentBinary = directions[directionIndex];
      var runs = buildRuns(currentBinary);

      for (var runIndex = 0; runIndex <= runs.length - 59; runIndex += 1) {
        var candidateRuns = runs.slice(runIndex, runIndex + 59);
        if (candidateRuns[0].color !== 1 || candidateRuns[58].color !== 1) continue;

        var start = candidateRuns[0].start;
        var end = candidateRuns[58].end;
        var moduleWidth = (end - start) / 95;
        if (moduleWidth < 0.65) continue;

        var guards = [
          candidateRuns[0], candidateRuns[1], candidateRuns[2],
          candidateRuns[27], candidateRuns[28], candidateRuns[29],
          candidateRuns[30], candidateRuns[31],
          candidateRuns[56], candidateRuns[57], candidateRuns[58]
        ];
        var guardsArePlausible = guards.every(function (run) {
          return run.length >= moduleWidth * 0.4 && run.length <= moduleWidth * 1.9;
        });
        if (!guardsArePlausible) continue;

        var bits = sampleCandidate(currentBinary, start, end);
        var decoded = decodeEanBits(bits);
        if (decoded) return decoded;
      }
    }

    return null;
  }

  function otsuThreshold(values) {
    var histogram = new Array(256).fill(0);
    values.forEach(function (value) {
      histogram[value] += 1;
    });

    var total = values.length;
    var totalSum = 0;
    histogram.forEach(function (count, value) {
      totalSum += value * count;
    });

    var backgroundWeight = 0;
    var backgroundSum = 0;
    var bestVariance = -1;
    var threshold = 127;

    for (var value = 0; value < 256; value += 1) {
      backgroundWeight += histogram[value];
      if (backgroundWeight === 0) continue;

      var foregroundWeight = total - backgroundWeight;
      if (foregroundWeight === 0) break;

      backgroundSum += value * histogram[value];
      var backgroundMean = backgroundSum / backgroundWeight;
      var foregroundMean = (totalSum - backgroundSum) / foregroundWeight;
      var variance =
        backgroundWeight *
        foregroundWeight *
        Math.pow(backgroundMean - foregroundMean, 2);

      if (variance > bestVariance) {
        bestVariance = variance;
        threshold = value;
      }
    }

    return threshold;
  }

  function smoothBinary(binary) {
    return binary.map(function (value, index) {
      if (index === 0 || index === binary.length - 1) return value;
      return binary[index - 1] + value + binary[index + 1] >= 2 ? 1 : 0;
    });
  }

  function decodeLuminanceLine(luminance) {
    var minimum = Math.min.apply(null, luminance);
    var maximum = Math.max.apply(null, luminance);
    if (maximum - minimum < 28) return null;

    var baseThreshold = otsuThreshold(luminance);
    var thresholds = [
      baseThreshold,
      Math.max(0, baseThreshold - 14),
      Math.min(255, baseThreshold + 14)
    ];

    for (var thresholdIndex = 0; thresholdIndex < thresholds.length; thresholdIndex += 1) {
      var threshold = thresholds[thresholdIndex];
      var binary = luminance.map(function (value) {
        return value < threshold ? 1 : 0;
      });
      var candidates = [binary, smoothBinary(binary)];

      for (var candidateIndex = 0; candidateIndex < candidates.length; candidateIndex += 1) {
        var decoded = decodeBinaryLine(candidates[candidateIndex]);
        if (decoded) return decoded;
      }
    }

    return null;
  }

  function decodeCanvasFrame(context, width, height) {
    var frame = context.getImageData(0, 0, width, height).data;
    var rows = [0.28, 0.36, 0.43, 0.5, 0.57, 0.64, 0.72];
    var slopes = [0, -0.05, 0.05, -0.1, 0.1, -0.16, 0.16];
    var sampleRadius = width >= 1600 ? 2 : 1;

    for (var slopeIndex = 0; slopeIndex < slopes.length; slopeIndex += 1) {
      var slope = slopes[slopeIndex];

      for (var rowIndex = 0; rowIndex < rows.length; rowIndex += 1) {
        var centerY = height * rows[rowIndex];
        var luminance = [];

        for (var x = 0; x < width; x += 1) {
          var y = Math.round(centerY + (x - width / 2) * slope);
          y = Math.max(0, Math.min(height - 1, y));
          var luminanceTotal = 0;
          var sampleCount = 0;

          for (var sampleOffset = -sampleRadius; sampleOffset <= sampleRadius; sampleOffset += 1) {
            var sampleY = Math.max(0, Math.min(height - 1, y + sampleOffset));
            var offset = (sampleY * width + x) * 4;
            luminanceTotal +=
              frame[offset] * 0.299 +
              frame[offset + 1] * 0.587 +
              frame[offset + 2] * 0.114;
            sampleCount += 1;
          }

          luminance.push(Math.round(luminanceTotal / sampleCount));
        }

        var decoded = decodeLuminanceLine(luminance);
        if (decoded) return decoded;
      }
    }

    return null;
  }

  async function optimizeCameraTrack(mediaStream) {
    var track = mediaStream && mediaStream.getVideoTracks
      ? mediaStream.getVideoTracks()[0]
      : null;
    if (!track) return;

    try {
      track.contentHint = "detail";
    } catch (error) {
      // contentHint is optional and can be read-only on older Safari versions.
    }

    if (!track.getCapabilities || !track.applyConstraints) return;

    try {
      var capabilities = track.getCapabilities();
      var advanced = [];

      if (
        Array.isArray(capabilities.focusMode) &&
        capabilities.focusMode.indexOf("continuous") !== -1
      ) {
        advanced.push({ focusMode: "continuous" });
      }

      if (
        Array.isArray(capabilities.exposureMode) &&
        capabilities.exposureMode.indexOf("continuous") !== -1
      ) {
        advanced.push({ exposureMode: "continuous" });
      }

      if (
        capabilities.zoom &&
        Number.isFinite(capabilities.zoom.min) &&
        Number.isFinite(capabilities.zoom.max) &&
        capabilities.zoom.max > capabilities.zoom.min
      ) {
        var preferredZoom = Math.min(
          capabilities.zoom.max,
          Math.max(capabilities.zoom.min, 1.8)
        );
        advanced.push({ zoom: preferredZoom });
      }

      if (advanced.length) {
        var currentConstraints = track.getConstraints
          ? track.getConstraints()
          : {
              width: { ideal: CAMERA_IDEAL_WIDTH },
              height: { ideal: CAMERA_IDEAL_HEIGHT }
            };
        currentConstraints.advanced = (currentConstraints.advanced || []).concat(advanced);
        await track.applyConstraints(currentConstraints);
      }
    } catch (error) {
      // Some iOS versions expose capabilities but reject camera tuning constraints.
    }
  }

  function createDetector() {
    if (!("BarcodeDetector" in window)) return Promise.resolve(null);

    if (typeof window.BarcodeDetector.getSupportedFormats !== "function") {
      try {
        return Promise.resolve(new window.BarcodeDetector({
          formats: ["ean_13", "ean_8", "upc_a", "upc_e", "code_128", "itf"]
        }));
      } catch (error) {
        return Promise.resolve(null);
      }
    }

    return window.BarcodeDetector.getSupportedFormats()
      .then(function (formats) {
        var wanted = ["ean_13", "ean_8", "upc_a", "upc_e", "code_128", "itf"].filter(function (format) {
          return formats.indexOf(format) !== -1;
        });
        return wanted.length
          ? new window.BarcodeDetector({ formats: wanted })
          : null;
      })
      .catch(function () {
        return null;
      });
  }

  async function findVariantUrl(barcode) {
    var rootRoute =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";
    var query = encodeURIComponent(barcode);
    var fields = [
      "title",
      "product_type",
      "variants.title",
      "vendor",
      "variants.sku",
      "variants.barcode"
    ].join(",");
    var url =
      rootRoute +
      "search/suggest?q=" +
      query +
      "&resources[type]=product" +
      "&resources[limit]=6" +
      "&resources[options][fields]=" +
      encodeURIComponent(fields) +
      "&section_id=predictive-search";

    try {
      var response = await fetch(url);
      if (!response.ok) return null;

      var documentResult = new DOMParser().parseFromString(
        await response.text(),
        "text/html"
      );
      var links = Array.from(
        documentResult.querySelectorAll(
          ".predictive-search__product-card a[href*='variant=']"
        )
      );
      var productLink = links.find(function (link) {
        var href = link.getAttribute("href") || "";
        var parsedUrl = new URL(href, window.location.origin);
        return parsedUrl.searchParams.has("variant");
      });

      if (!productLink) return null;

      var productUrl = new URL(
        productLink.getAttribute("href"),
        window.location.origin
      );
      productUrl.searchParams.set("find_in_store", "1");
      return productUrl.href;
    } catch (error) {
      return null;
    }
  }

  function autoOpenStoreAvailability() {
    var currentUrl = new URL(window.location.href);
    if (currentUrl.searchParams.get("find_in_store") !== "1") return;

    var attempts = 0;
    var maxAttempts = 80;
    var timer = window.setInterval(function () {
      attempts += 1;
      var button = document.querySelector(".stock-checker-btn");

      if (button) {
        window.clearInterval(timer);
        elevateStockCheckerModal(button);
        currentUrl.searchParams.delete("find_in_store");
        window.history.replaceState({}, "", currentUrl.href);
        window.setTimeout(function () {
          button.click();
        }, 100);
        return;
      }

      if (attempts >= maxAttempts) {
        window.clearInterval(timer);
      }
    }, 100);
  }

  function elevateStockCheckerModal(button) {
    var blockId = button && button.dataset ? button.dataset.blockId : null;
    var modal = blockId
      ? document.getElementById("stock-checker-modal-" + blockId)
      : document.querySelector(".stock-checker-modal");

    if (modal && modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
  }

  function prepareStockCheckerModals() {
    document.addEventListener("click", function (event) {
      var button = event.target.closest
        ? event.target.closest(".stock-checker-btn")
        : null;
      if (button) elevateStockCheckerModal(button);
    }, true);
  }

  function initScanner(root) {
    if (root.dataset.barcodeScannerReady === "true") return;
    root.dataset.barcodeScannerReady = "true";

    var openButton = root.querySelector(".js-barcode-scanner-open");
    var dialog = root.querySelector(".js-barcode-scanner");
    var closeButton = root.querySelector(".js-barcode-scanner-close");
    var video = root.querySelector(".js-barcode-scanner-video");
    var status = root.querySelector(".js-barcode-scanner-status");
    var manualInput = root.querySelector(".js-barcode-scanner-manual");
    var useCodeButton = root.querySelector(".js-barcode-scanner-use-code");
    var searchInput = root.querySelector(".js-predictive-search-input");

    if (!openButton || !dialog || !video || !searchInput) return;

    var canvas = document.createElement("canvas");
    var context = canvas.getContext("2d", { willReadFrequently: true });
    var stream = null;
    var animationFrame = null;
    var detector = null;
    var detecting = false;
    var lastScan = 0;
    var scanPass = 0;

    function setStatus(message) {
      status.textContent = message;
    }

    function stopCamera() {
      if (animationFrame) {
        window.cancelAnimationFrame(animationFrame);
        animationFrame = null;
      }
      if (stream) {
        stream.getTracks().forEach(function (track) {
          track.stop();
        });
        stream = null;
      }
      video.srcObject = null;
      detecting = false;
      document.documentElement.classList.remove("barcode-scanner-open");
    }

    function closeScanner() {
      stopCamera();
      if (dialog.open) dialog.close();
    }

    async function useBarcode(rawValue) {
      var value = String(rawValue || "").trim().replace(/\s+/g, "");
      if (!value) return;

      setStatus(dialog.dataset.detected + ": " + value);
      if (navigator.vibrate) navigator.vibrate(80);
      closeScanner();

      searchInput.value = value;
      searchInput.focus();

      var variantUrl = await findVariantUrl(value);
      if (variantUrl) {
        window.location.assign(variantUrl);
        return;
      }

      searchInput.dispatchEvent(new Event("input", { bubbles: true }));
    }

    function drawScanPass(useDistantCrop) {
      var sourceScale = useDistantCrop ? DISTANT_SCAN_CROP : 1;
      var sourceWidth = Math.max(1, Math.round(video.videoWidth * sourceScale));
      var sourceHeight = Math.max(1, Math.round(video.videoHeight * sourceScale));
      var sourceX = Math.round((video.videoWidth - sourceWidth) / 2);
      var sourceY = Math.round((video.videoHeight - sourceHeight) / 2);
      var width = Math.min(SCAN_MAX_WIDTH, video.videoWidth);
      var height = Math.max(1, Math.round(width * sourceHeight / sourceWidth));

      canvas.width = width;
      canvas.height = height;
      context.imageSmoothingEnabled = true;
      context.imageSmoothingQuality = "high";
      context.drawImage(
        video,
        sourceX,
        sourceY,
        sourceWidth,
        sourceHeight,
        0,
        0,
        width,
        height
      );

      return decodeCanvasFrame(context, width, height);
    }

    async function scanFrame(timestamp) {
      if (!stream || !dialog.open) return;
      animationFrame = window.requestAnimationFrame(scanFrame);

      if (detecting || timestamp - lastScan < SCAN_INTERVAL || video.readyState < 2) return;
      lastScan = timestamp;
      detecting = true;

      try {
        if (detector) {
          var barcodes = await detector.detect(video);
          if (barcodes.length && barcodes[0].rawValue) {
            useBarcode(barcodes[0].rawValue);
            return;
          }
        }

        if (context && video.videoWidth && video.videoHeight) {
          var useDistantCrop = scanPass % 2 === 1;
          scanPass += 1;
          var decoded = drawScanPass(useDistantCrop);
          if (decoded) {
            useBarcode(decoded);
            return;
          }
        }
      } catch (error) {
        detector = null;
      } finally {
        detecting = false;
      }
    }

    async function openScanner() {
      if (!window.matchMedia(MOBILE_QUERY).matches) return;

      if (typeof dialog.showModal === "function") {
        dialog.showModal();
      } else {
        dialog.setAttribute("open", "");
      }
      document.documentElement.classList.add("barcode-scanner-open");
      manualInput.value = "";
      setStatus(dialog.dataset.starting);

      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        setStatus(dialog.dataset.unsupported);
        manualInput.focus();
        return;
      }

      try {
        try {
          stream = await navigator.mediaDevices.getUserMedia({
            audio: false,
            video: {
              facingMode: { exact: "environment" },
              width: { ideal: CAMERA_IDEAL_WIDTH },
              height: { ideal: CAMERA_IDEAL_HEIGHT },
              aspectRatio: { ideal: 1.7777777778 },
              frameRate: { ideal: 30 },
              resizeMode: { ideal: "none" }
            }
          });
        } catch (cameraError) {
          stream = await navigator.mediaDevices.getUserMedia({
            audio: false,
            video: {
              facingMode: { ideal: "environment" },
              width: { ideal: CAMERA_IDEAL_WIDTH },
              height: { ideal: CAMERA_IDEAL_HEIGHT },
              aspectRatio: { ideal: 1.7777777778 },
              frameRate: { ideal: 30 }
            }
          });
        }
        video.srcObject = stream;
        await video.play();
        await optimizeCameraTrack(stream);
        detector = await createDetector();
        setStatus(dialog.dataset.instructions);
        animationFrame = window.requestAnimationFrame(scanFrame);
      } catch (error) {
        stopCamera();
        document.documentElement.classList.add("barcode-scanner-open");
        setStatus(dialog.dataset.denied);
        manualInput.focus();
      }
    }

    openButton.addEventListener("click", openScanner);
    closeButton.addEventListener("click", closeScanner);
    dialog.addEventListener("cancel", function (event) {
      event.preventDefault();
      closeScanner();
    });
    dialog.addEventListener("close", stopCamera);
    useCodeButton.addEventListener("click", function () {
      useBarcode(manualInput.value);
    });
    manualInput.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        event.preventDefault();
        useBarcode(manualInput.value);
      }
    });
  }

  function init() {
    prepareStockCheckerModals();
    autoOpenStoreAvailability();
    document.querySelectorAll(".js-predictive-search").forEach(initScanner);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
